export const IGNORED_ATTRIBUTES = [
  'referrer',
  'title',
  'url',
  'createdAt',
  'endedAt',
  'sessionId'
]



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EventData/constants.js